import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

interface NavItem {
  id: string;
  label: string;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  private _activeModule = 'portfolio';

  @Input()
  set activeModule(val: string) {
    this._activeModule = val;
    if (this.techMapItems.some(i => i.id === val)) {
      this.techMapOpen = true;
    }
    if (this.tbmItems.some(i => i.id === val)) {
      this.tbmOpen = true;
    }
  }
  get activeModule(): string { return this._activeModule; }

  @Output() moduleSwitch = new EventEmitter<string>();

  techMapOpen = false;

  navItems: NavItem[] = [
    { id: 'portfolio',            label: 'Base Hierarchy' },
    { id: 'initiative',           label: 'Initiatives' },
    { id: 'risk',                 label: 'Risks' },
    { id: 'okr',                  label: 'OKRs' },
    { id: 'delivery_obligations', label: 'Delivery Obligations' },
    { id: 'metrics',              label: 'Metrics' },
    { id: 'vendor_master',        label: 'Vendors' },
    { id: 'workforce_catalog',    label: 'Workforce Catalog' },
    { id: 'profit_cost_centres',   label: 'Profit-Cost Centres' },
    { id: 'people_competency_map', label: 'People Competency Map' },
    { id: 'turnkey_plans',         label: 'Plans' },
    { id: 'module_owners',         label: 'Zone Owners' },
    { id: 'catalog_owners',        label: 'Catalog Owners' },
  ];

  techMapItems: NavItem[] = [
    { id: 'tech_map_applications',    label: 'Applications' },
    { id: 'tech_map_infrastructures', label: 'Infrastructures' },
    { id: 'tech_map_services',        label: 'Services' },
  ];

  get isTechMapActive(): boolean {
    return this.techMapItems.some(i => i.id === this.activeModule);
  }

  tbmOpen = false;

  tbmItems: NavItem[] = [
    { id: 'tbm_cost_pool', label: 'Cost Pool' },
    { id: 'tbm_it_tower',  label: 'IT Tower' },
    { id: 'tbm_service',   label: 'Service Catalog' },
    { id: 'tbm_solution',  label: 'Solutions' },
  ];

  get isTbmActive(): boolean {
    return this.tbmItems.some(i => i.id === this.activeModule);
  }

  switch(id: string): void {
    this.moduleSwitch.emit(id);
  }

  toggleTechMap(): void {
    this.techMapOpen = !this.techMapOpen;
  }

  toggleTbm(): void {
    this.tbmOpen = !this.tbmOpen;
  }
}
